export const nl = {
  // Navigation
  navigation: {
    singleVerification: 'Enkele Verificatie',
    batchVerification: 'Batch Verificatie',
    about: 'Over',
    logout: 'Uitloggen'
  },
  auth: {
    emailVerification: {
      title: 'Verifieer Uw Email',
      message: 'We hebben een verificatie-email gestuurd naar {email}. Controleer uw inbox en klik op de verificatielink om uw account te activeren.',
      checkEmail: 'Controleer uw email',
      followInstructions: 'Volg de instructies in de email om uw account te verifiëren.',
      resendEmail: 'Verificatie-email Opnieuw Verzenden',
      sending: 'Verzenden...',
      backToLogin: 'Terug naar Inloggen',
      emailSent: 'Verificatie-email succesvol verzonden!',
      helpText: 'Als u de email niet in uw inbox ziet, controleer dan uw spam-map.'
    }
  },

  // Header
  header: {
    title: 'Peppol BTW Verificatie',
    subtitle: 'EU BTW & Peppol Verificatie Tool'
  },

  // Footer
  footer: {
    description: 'Peppol BTW Verificatie Tool - Gebouwd met React & TypeScript',
    disclaimer: 'Alleen voor demonstratiedoeleinden. Productiegebruik vereist juiste API-integratie.',
    termsOfUse: 'Gebruiksvoorwaarden',
    privacyPolicy: 'Privacybeleid'
  },

  // About Page
  about: {
    title: 'Over Peppol BTW Verificatie',
    overview: {
      title: 'Overzicht',
      content: 'Deze applicatie biedt verificatieservices voor EU BTW-nummers en Peppol deelnemer-ID\'s. Het ondersteunt zowel enkele bedrijfsverificatie als batchverwerking voor meerdere invoeren.'
    },
    features: {
      title: 'Functies',
      items: [
        { label: 'EU BTW Verificatie:', description: 'Valideer BTW-nummers met behulp van VIES (BTW Informatie Uitwisselingssysteem)' },
        { label: 'Peppol Verificatie:', description: 'Controleer deelnemer-ID\'s tegen de Peppol directory' },
        { label: 'Dubbele Verificatie:', description: 'Voer zowel BTW als Peppol verificatie uit met één identificatie' },
        { label: 'Enkele Verificatie:', description: 'Verificeer individuele bedrijven met gedetailleerde resultaten' },
        { label: 'Batch Verwerking:', description: 'Upload CSV-bestanden voor bulkverificatie' },
        { label: 'Echte API Integratie:', description: 'Schakel tussen echte API-aanroepen en simulatiemodus' },
        { label: 'Exporteer Resultaten:', description: 'Download verificatieresultaten als CSV-bestanden' },
        { label: 'Template Downloads:', description: 'Krijg CSV-sjablonen voor juiste dataformattering' }
      ]
    },
    vatFormats: {
      title: 'Ondersteunde BTW-nummer Formaten',
      description: 'De applicatie ondersteunt BTW-nummers van alle EU-lidstaten:',
      examples: [
        'Oostenrijk: U12345678',
        'België: 1234567890',
        'Duitsland: 123456789',
        'Frankrijk: AB123456789',
        'Italië: 12345678901',
        'Nederland: 123456789B01',
        'Spanje: A12345678',
        'En nog veel meer...'
      ]
    },
    peppolTypes: {
      title: 'Peppol Deelnemer ID Typen',
      items: [
        { type: 'DUNS:', description: '9-cijferig Data Universal Numbering System' },
        { type: 'GLN:', description: '12-15 cijferig Global Location Number' },
        { type: 'BTW:', description: 'Landcode + BTW-nummer' },
        { type: 'Aangepast:', description: 'Organisatie-specifieke identificaties' }
      ]
    },
    apiMode: {
      title: 'API Modus Schakelaar',
      description: 'De applicatie bevat een schakelaar om te kiezen tussen:',
      items: [
        { mode: 'Simulatie Modus:', description: 'Gebruikt mock data voor demonstratiedoeleinden' },
        { mode: 'Echte API Modus:', description: 'Maakt echte aanroepen naar VIES en Peppol API\'s' }
      ]
    },
    importantNotes: {
      title: 'Belangrijke Opmerkingen',
      items: [
        'Echte API-modus vereist juiste netwerktoegang tot VIES en Peppol services',
        'Sommige API\'s kunnen rate limiting hebben of authenticatie vereisen',
        'Simulatiemodus wordt aanbevolen voor testen en demonstratie',
        'Productiegebruik moet juiste foutafhandeling en retry-logica bevatten'
      ]
    },
    technicalDetails: {
      title: 'Technische Details',
      content: 'Gebouwd met React, TypeScript en Tailwind CSS. Gebruikt Papa Parse voor CSV-verwerking en bevat uitgebreide foutafhandeling en gebruikersfeedback.'
    }
  },

  // Terms of Use
  termsOfUse: {
    title: 'Gebruiksvoorwaarden – vateu.eu',
    sections: {
      scope: {
        title: '1. Bereik en Beta Status',
        content: 'De Service wordt gratis verstrekt alleen voor evaluatiedoeleinden. Het wordt momenteel aangeboden aan geselecteerde testers, inclusief Shell, om kwaliteit en effectiviteit te beoordelen voordat er een mogelijke commerciële release is. Geen productiegebruik wordt aanbevolen. De Service kan op elk moment worden gewijzigd, opgeschort of stopgezet zonder kennisgeving.'
      },
      dataSources: {
        title: '2. Data Bronnen',
        content: 'BTW-validaties worden uitgevoerd met behulp van het VIES-systeem van de EU-Commissie en verbonden nationale databases. Peppol-validaties zijn gebaseerd op openbare Peppol Directory / SMP bronnen. Wij zijn niet gelieerd aan de Europese Commissie, enige nationale belastingautoriteit of OpenPeppol.'
      },
      accuracy: {
        title: '3. Nauwkeurigheid en Beschikbaarheid',
        content: 'Informatie kan vertraagd, onvolledig of niet beschikbaar zijn door downtime van derde partij systemen. De Service wordt geleverd "zoals deze is", zonder enige garanties. Geen rechten of verplichtingen kunnen worden afgeleid van validatieresultaten.'
      },
      acceptableUse: {
        title: '4. Aanvaardbaar Gebruik',
        content: 'Gebruikers mogen de Service niet misbruiken door excessieve geautomatiseerde verzoeken. Bulk queries zijn onderworpen aan rate-limits en kunnen worden geblokkeerd. De Service mag niet worden gebruikt voor onwettige doeleinden.'
      },
      intellectualProperty: {
        title: '5. Intellectueel Eigendom',
        content: 'De inhoud, code en het ontwerp van vateu.eu zijn eigendom van Mariusz Pietruszka (PL6572490600) "VIES" en "Peppol" zijn namen van derde partijen; wij claimen geen rechten hierop en gebruiken ze alleen beschrijvend. Gebruik het EU-embleem of Peppol-logo\'s niet in verband met deze Service.'
      },
      privacy: {
        title: '6. Privacy en Data Handling',
        content: 'De Service slaat niet permanent BTW-nummers, Peppol-identificaties of validatieresultaten op die door gebruikers zijn ingediend. Invoerdata wordt alleen verzonden naar de relevante derde partij validatiesystemen (bijv. VIES, Peppol Directory) en alleen verwerkt om het validatieresultaat te genereren dat aan u wordt getoond. Na het terugkeren van het resultaat wordt geen kopie van de invoerdata of validatie-output behouden in ons systeem, behalve voor korte-termijn technische logs (zie Privacybeleid).'
      },
      liability: {
        title: '7. Aansprakelijkheid',
        content: 'Voor zover wettelijk toegestaan, verklaren wij alle garanties, expliciet of impliciet, van de hand. Wij aanvaarden geen aansprakelijkheid voor directe, indirecte of gevolgschade als gevolg van gebruik van de Service.'
      },
      changes: {
        title: '8. Wijzigingen',
        content: 'Wij kunnen deze Voorwaarden op elk moment bijwerken. Voortgezet gebruik betekent acceptatie van de herziene Voorwaarden.'
      },
      governingLaw: {
        title: '9. Toepasselijk Recht',
        content: 'Deze Voorwaarden worden beheerst door de wetten van Polen. Eventuele geschillen vallen onder de exclusieve jurisdictie van de rechtbanken van Polen.',
        contact: 'Contact: Mariusz Pietruszka – PL6572490600'
      }
    }
  },

  // Privacy Policy
  privacyPolicy: {
    title: 'Privacybeleid – vateu.eu',
    effectiveDate: 'Ingangsdatum: 14/09/2025',
    sections: {
      controller: {
        title: '1. Controller',
        content: 'De Service wordt geëxploiteerd door: [Uw bedrijfsnaam, geregistreerd adres, contact email] Voor privacy-inquêtes, contact: [privacy@vateu.eu].'
      },
      dataWeProcess: {
        title: '2. Data die Wij Verwerken',
        inputData: 'Invoerdata: BTW-nummers en Peppol-identificaties die u indient voor validatie worden alleen in geheugen verwerkt en verzonden naar VIES of de Peppol Directory. Wij slaan deze identificaties of validatieresultaten niet op.',
        logs: 'Logs: minimale technische data (IP-adres, browsertype, timestamp, foutlogs) kunnen worden verzameld om beveiliging te waarborgen en problemen op te lossen.',
        optionalContact: 'Optioneel contact: als u contact opneemt via email of formulier, verwerken wij uw contactgegevens en bericht.'
      },
      purposeAndLegalBasis: {
        title: '3. Doel en Juridische Grondslag',
        items: [
          'Om validatieresultaten te verstrekken (ons legitieme belang, Art. 6(1)(f) AVG).',
          'Om misbruik te voorkomen en systeemstabiliteit te waarborgen (legitiem belang).',
          'Om met u te communiceren als u contact met ons opneemt (uitvoering van een contract, Art. 6(1)(b) AVG).'
        ]
      },
      dataRetention: {
        title: '4. Data Bewaring',
        items: [
          'BTW/Peppol ID\'s en validatieresultaten worden niet opgeslagen nadat het validatieverzoek is voltooid.',
          'Logs worden maximaal [bijv. 30 dagen] bewaard en vervolgens verwijderd of geanonimiseerd.',
          'Contactdata wordt bewaard zolang nodig om uw verzoek te beantwoorden.'
        ]
      },
      dataSharing: {
        title: '5. Data Delen',
        items: [
          'Validatieverzoeken worden verzonden naar VIES (Europese Commissie) en/of Peppol Directory systemen.',
          'Wij verkopen of delen geen persoonlijke data met derde partijen voor marketingdoeleinden.',
          'Hosting en infrastructuurproviders kunnen data voor ons verwerken onder dataverwerkingsovereenkomsten.'
        ]
      },
      internationalTransfers: {
        title: '6. Internationale Overdrachten',
        content: 'Data kan worden verwerkt op servers gelegen in de EU/EEA. Als overdrachten buiten de EU/EEA plaatsvinden, zorgen wij voor passende waarborgen (bijv. Standaard Contractuele Bepalingen).'
      },
      yourRights: {
        title: '7. Uw Rechten',
        description: 'U heeft rechten onder de AVG, waaronder:',
        items: [
          'Toegang tot uw data',
          'Rectificatie of wissen',
          'Beperking of bezwaar tegen verwerking',
          'Dataportabiliteit',
          'Indienen van een klacht bij uw toezichthoudende autoriteit'
        ]
      },
      cookiesAnalytics: {
        title: '8. Cookies & Analytics',
        content: 'Wij gebruiken alleen essentiële cookies voor servicefunctionaliteit. Als wij analytics of niet-essentiële cookies introduceren, zullen wij om toestemming vragen.'
      },
      changes: {
        title: '9. Wijzigingen',
        content: 'Wij kunnen dit Privacybeleid bijwerken. De nieuwste versie zal altijd beschikbaar zijn op de site.'
      },
      contact: {
        title: '10. Contact',
        content: 'Voor vragen of verzoeken betreffende dit Privacybeleid, email [privacy@vateu.eu].'
      }
    }
  },

  // Single Verification
  singleVerification: {
    title: 'Enkele Verificatie',
    verificationType: 'Verificatie Type',
    types: {
      vat: 'EU BTW Verificatie',
      peppol: 'Peppol Verificatie',
      both: 'Beide Verificaties'
    },
    forms: {
      vatNumber: 'BTW Nummer',
      vatNumberPlaceholder: 'bijv. NL123456789B01',
      peppolId: 'Peppol Deelnemer ID',
      peppolIdPlaceholder: 'bijv. 123456789 (DUNS) of 1234567890123 (GLN)',
      peppolIdHelp: 'Voer een DUNS nummer, GLN, BTW nummer, of aangepast deelnemer ID in',
      companyIdentifier: 'Bedrijf Identificatie',
      companyIdentifierPlaceholder: 'bijv. NL123456789B01, 123456789, of 1234567890123',
      companyIdentifierHelp: 'Voer een BTW nummer (NL123456789B01), DUNS (123456789), GLN (1234567890123), of ander identificatie in',
      unifiedTitle: 'Geïntegreerde Verificatie',
      unifiedDescription: 'Voer een enkele identificatie in die gebruikt zal worden voor zowel BTW als Peppol verificatie. Dit kan een BTW nummer, DUNS, GLN, of andere bedrijfsidentificatie zijn.'
    },
    buttons: {
      verify: 'Verifiëren',
      verifying: 'Verifiëren...',
      reset: 'Resetten'
    },
    apiMode: {
      simulationMode: 'Simulatie Modus',
      realAPI: 'Echte API',
      simulation: 'Simulatie'
    },
    results: {
      verificationSuccessful: 'Verificatie Succesvol',
      verificationFailed: 'Verificatie Mislukt',
      verificationResults: 'Verificatie Resultaten',
      vatVerification: 'BTW Verificatie',
      peppolVerification: 'Peppol Verificatie',
      fields: {
        vatNumber: 'BTW Nummer',
        companyName: 'Bedrijfsnaam',
        address: 'Adres',
        fullParticipantId: 'Volledige Deelnemer ID',
        participantName: 'Deelnemer Naam',
        participantId: 'Deelnemer ID',
        scheme: 'Schema',
        supportedDocumentTypes: 'Ondersteunde Document Types',
        supportsBilling: 'Ondersteunt Facturering',
        error: 'Fout',
        verifiedAt: 'Geverifieerd op',
        yes: 'Ja',
        no: 'Nee'
      },
      multipleMatches: {
        title: 'Meerdere Matches Gevonden',
        matchCount: 'matches',
        match: 'Match'
      }
    }
  },

  // Batch Verification
  batchVerification: {
    title: 'Batch Verificatie',
    inputMethod: 'Invoer Methode',
    methods: {
      csv: 'CSV Upload',
      textarea: 'Tekst Invoer'
    },
    forms: {
      uploadFile: 'Upload CSV Bestand',
      downloadTemplate: 'Download CSV Sjabloon',
      textAreaPlaceholder: 'Voer identificaties in gescheiden door komma\'s of nieuwe regels (bijv. NL123456789B01, 123456789, 1234567890123)',
      textAreaHelp: 'Voer een of meer identificaties per regel in. Scheid meerdere identificaties op dezelfde regel met komma\'s.',
      textInputTitle: 'Voor tekst invoer, voer identificaties in gescheiden door komma\'s:',
      textInputDescription: 'Voer identificaties in gescheiden door komma\'s. Elke regel kan meerdere identificaties bevatten. Ondersteunt BTW nummers, DUNS, GLN en andere bedrijfsidentificaties.',
      textInputRules: [
        'Elke regel kan meerdere identificaties bevatten gescheiden door komma\'s',
        'Ondersteunt BTW nummers (NL123456789B01), DUNS (123456789), GLN (1234567890123)',
        'Lege regels worden genegeerd',
        'Witruimte rond identificaties wordt automatisch weggesneden'
      ],
      dualVerificationHelp: 'De identificatie kan een BTW nummer, DUNS, GLN, of andere bedrijfsidentificatie zijn die werkt voor zowel BTW als Peppol verificatie.',
      identifiersReady: 'identificaties klaar voor verificatie',
      exportResults: 'Exporteer resultaten',
      textInputPlaceholder: 'Voer identificaties in gescheiden door komma\'s. Elke regel kan meerdere identificaties bevatten:\n\nNL123456789B01, DE123456789\n123456789, 987654321\n1234567890123',
      textInputHelp: 'Voer identificaties in gescheiden door komma\'s. Elke regel kan meerdere identificaties bevatten. Ondersteunt BTW nummers, DUNS, GLN en andere bedrijfsidentificaties.'
    },
    buttons: {
      process: 'Verificatie Verwerken',
      processing: 'Verwerken...',
      downloadResults: 'Resultaten Downloaden',
      reset: 'Resetten',
      cancel: 'Annuleren'
    },
    results: {
      summary: 'Verificatie Samenvatting',
      totalProcessed: 'Totaal Verwerkt',
      valid: 'Geldig',
      invalid: 'Ongeldig',
      errors: 'Fouten',
      processingTime: 'Verwerkingstijd',
      noResults: 'Geen resultaten om weer te geven',
      exportResults: 'Resultaten Exporteren',
      vatVerification: 'BTW Verificatie',
      dualVerificationResults: 'Dubbele Verificatie Resultaten'
    },
    progress: {
      processing: 'Verificatie verwerken...',
      completed: 'Verwerking voltooid'
    },
    format: {
      csvRequirements: 'CSV Formaat Vereisten',
      textInputFormat: 'Tekst Invoer Formaat',
      dualVerificationTitle: 'Voor dubbele verificatie, voeg deze kolommen toe:',
      dualVerificationColumns: [
        'identifier of id - Bedrijfsidentificatie (vereist)',
        'Alternatieve kolomnamen: vatNumber, vat, taxId, participantId, peppolId'
      ],
      vatVerificationTitle: 'Voor BTW verificatie, voeg deze kolommen toe:',
      vatVerificationColumns: [
        'vatNumber of vat of taxId - BTW nummer (vereist)'
      ],
      peppolVerificationTitle: 'Voor Peppol verificatie, voeg deze kolommen toe:',
      peppolVerificationColumns: [
        'participantId of peppolId of id - Deelnemer ID (vereist)'
      ]
    }
  },

  // Error Messages
  errors: {
    general: {
      unknownError: 'Onbekende fout opgetreden',
      networkError: 'Netwerkfout opgetreden',
      parsingError: 'Fout bij het parseren van CSV bestand. Controleer het formaat.',
      noDataToProcess: 'Upload een CSV bestand of voer identificaties in het tekstgebied in.',
      invalidInput: 'Ongeldige invoer opgegeven'
    },
    vat: {
      invalidFormat: 'Ongeldig BTW nummer formaat',
      countryNotSupported: 'Land niet ondersteund door VIES',
      serviceUnavailable: 'VIES service momenteel niet beschikbaar',
      timeout: 'Request timeout - VIES service kan traag zijn',
      rateLimit: 'Rate limit overschreden - probeer het later opnieuw'
    },
    peppol: {
      invalidFormat: 'Ongeldig Peppol deelnemer ID formaat',
      serviceUnavailable: 'Peppol service momenteel niet beschikbaar',
      timeout: 'Request timeout - Peppol service kan traag zijn',
      notFound: 'Deelnemer niet gevonden in Peppol directory',
      rateLimit: 'Rate limit overschreden - probeer het later opnieuw'
    },
    serviceUnavailable: {
      title: 'Service Niet Beschikbaar',
      message: 'De {service} service is momenteel niet beschikbaar vanwege hoge vraag of onderhoud. We zullen uw verzoek automatisch opnieuw proberen.',
      autoRetryIn: 'Automatische nieuwe poging over:',
      retryNow: 'Nu Opnieuw Proberen',
      cancel: 'Annuleren',
      helpText: 'U kunt handmatig opnieuw proberen of wachten op de automatische nieuwe poging. De service zal zo snel mogelijk worden hersteld.'
    }
  }
};
